<div class="row">

    <div class="col-12">
        <h1 class="text-center"></h1>
        <p class="small text-muted text-center">version: {{environment.version}}</p>
    </div>

</div>
